import { render, staticRenderFns } from "./MoveItemIcon.vue?vue&type=template&id=18c6dbb4&scoped=true"
import script from "./MoveItemIcon.vue?vue&type=script&lang=js"
export * from "./MoveItemIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c6dbb4",
  null
  
)

export default component.exports